import {
  Button,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Image,
} from "@chakra-ui/react";
import React from "react";
import { IDropdownItem } from "../_types_";

interface IProps {
  data: IDropdownItem[];
  selectedValue?: string | number;
  onValueChange?: (val: string | number) => void;
  defaultLabel: string;
}

export default function Kvhc({ data, selectedValue, defaultLabel, onValueChange }: IProps) {
  const selectedLabel = selectedValue ? data.find((p) => p.value === selectedValue)?.lable : defaultLabel;
  return (
    <Menu>
      <MenuButton bg="white" px="10px" py="10px" border="1px solid #f1f1f1">
        <HStack>
          <Text> {selectedLabel}</Text>
          <Image src="./imgs/arrow-down.svg" />
        </HStack>
      </MenuButton>
      <MenuList>
        {data.map((item) => (
          <MenuItem key={item.value} onClick={() => onValueChange && onValueChange(item.value)}>{item.lable}</MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
